export * as DocsService from './DocsService.js'; // eslint-disable-line



// WEBPACK FOOTER //
// ./services/index.js